/* eslint-disable no-undef */
// import Chart from 'chart.js';
export default (context, {
  type = '',
  chartData = [],
  options = {},
}) => {
  // Set some defaults
  Chart.defaults.font.family = 'Roboto, sans-serif';
  Chart.defaults.font.size = 16;
  Chart.defaults.font.weight = '300';
  Chart.defaults.font.color = '#1d2022';
  Chart.defaults.color = '#1d2022';

  Chart.defaults.elements.bar.borderColor = 'transparent';
  Chart.defaults.elements.bar.barThickness = 'flex';

  Chart.defaults.elements.line.tension = 0.25;
  Chart.defaults.elements.point.pointStyle = 'line';

  Chart.defaults.elements.arc.borderWidth = 0;

  // console.log('chart defaults', Chart.defaults);

  /**
   * Add plugin to allow for centering text.
   * For example inside the doughnut-chart.
   */
  Chart.register({
    id: 'center-inside-text',
    afterDatasetsDraw: function (chart) {
      if (!chart.config.options.useCenterText) {
        return;
      }
      const width = chart.width,
        height = chart.height,
        ctx = chart.ctx;

      ctx.restore();
      const fontSize = (height / 100).toFixed(2);
      ctx.font = 'bold ' + fontSize + 'em "Montserrat", sans-serif';
      ctx.textBaseline = 'middle';

      const text = chart.config.options.centerText,
        textX = Math.round((width - ctx.measureText(text).width) / 2),
        textY = (height / 2) - (chart.config.options.plugins.title.display ? 15 : 0);

      ctx.fillText(text, textX, textY);
      ctx.font = 'bold 24px "Montserrat", sans-serif';
      ctx.save();
    },
  });

  return new Chart(context, {
    type: type,
    data: chartData,
    options: options,
  });
};
